/**
 * Fire-and-forget PATCH to persist reviewer state on a claim.
 * Best-effort — failures are silently swallowed.
 *
 * The `review_state` JSONB column carries both source-level and passage-level
 * removals. The column is set to NULL only when both sets are empty.
 */
import { apiFetch } from './apiFetch'
import type { ReviewState } from '@/types/api'

export function persistReviewState(
  claimUuid: string,
  hiddenSourceIds: string[],
  hiddenPassageIds: string[] = [],
): void {
  const hasHiddenSources = hiddenSourceIds.length > 0
  const hasHiddenPassages = hiddenPassageIds.length > 0

  let reviewState: ReviewState | null = null
  if (hasHiddenSources || hasHiddenPassages) {
    reviewState = {}
    if (hasHiddenSources) reviewState.hidden_source_ids = hiddenSourceIds
    if (hasHiddenPassages) reviewState.hidden_passage_ids = hiddenPassageIds
  }

  apiFetch(`/api/claims/${claimUuid}`, {
    method: 'PATCH',
    body: JSON.stringify({ review_state: reviewState }),
  }).catch(() => {}) // best-effort
}
